module.exports = __webpack_public_path__ + "img/resend-order.7fc4a3a8.svg";